/**
 * AvgDaysBarChart — recharts BarChart fuer DASH-03 (Phase 4 Plan 03).
 *
 * Zeigt Ø Verweildauer pro Kanban-Spalte in Tagen.
 * X = Status-Label (lesbar), Y = Tage.
 * Bar fill #E9FF57 (Gelb), Stroke #1A1A1A (Schwarz).
 * Responsiv via ResponsiveContainer height=250.
 */

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';

const STATUS_LABELS: Record<string, string> = {
  lead_form: 'Lead-Formular',
  followup_1: 'Follow-up 1',
  followup_2: 'Follow-up 2',
  in_kontakt: 'In Kontakt',
  positiv: 'Positiv',
  negativ: 'Negativ',
  negativ_hotlead: 'Neg. Hotlead',
};

interface AvgDaysBarChartProps {
  data: Record<string, number>;
}

export default function AvgDaysBarChart({ data }: AvgDaysBarChartProps) {
  const chartData = Object.entries(data).map(([status, avgDays]) => ({
    status: STATUS_LABELS[status] ?? status,
    avgDays,
  }));

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#DAD9D9" />
        <XAxis
          dataKey="status"
          stroke="#1A1A1A"
          tick={{ fontSize: 10, fill: '#1A1A1A' }}
          interval={0}
          angle={-25}
          textAnchor="end"
          height={55}
        />
        <YAxis
          stroke="#1A1A1A"
          tick={{ fontSize: 11, fill: '#1A1A1A' }}
          allowDecimals={false}
          width={35}
          label={{ value: 'Tage', angle: -90, position: 'insideLeft', fontSize: 11, fill: '#1A1A1A' }}
        />
        <Tooltip
          contentStyle={{ borderColor: '#DAD9D9', fontSize: 12 }}
          formatter={(value: number) => [`${value} Tage`, 'Ø Verweildauer']}
        />
        <Bar dataKey="avgDays" fill="#E9FF57" stroke="#1A1A1A" strokeWidth={1} />
      </BarChart>
    </ResponsiveContainer>
  );
}
